import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  cardWrapper: {
    width: '100%',
    minHeight: '65px',
    backgroundColor: 'white',
    border: '0.1px solid rgba(0, 0, 0, 10%)',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '25px',
    padding: '10px 25px',
    height: '100%',
  },
  cardTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 3,
    marginBlock: '15px',
    alignSelf: 'flex-start',
  },
  cardTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  cardSubTitle: {
    marginTop: '-5px',
    fontSize: '12px',
    color: 'gray',
  },
  cardFileWrapper: {
    flex: 8,
    display: 'flex',
    flexFlow: 'row wrap',

    // Override Upload file list styles for inline display.
    '& .ant-upload-list': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: '8px',
    },

    '& .ant-upload-list-item': {
      display: 'flex',
      alignItems: 'center',
      // Adjust the spacing or minWidth if needed
    },

    // Make the PDF icon and paperclip icon bigger
    '& .ant-upload-list-item .anticon': {
      fontSize: '18px',
      width: '18px',
      height: '18px',
      lineHeight: '18px',
      backgroundColor: 'blue',
    },

    // Specifically enlarge the remove/delete icon
    '& .ant-upload-list-item-card-actions .anticon-delete, .ant-upload-list-item-card-actions .anticon-close': {
      fontSize: '18px',
      width: '18px',
      height: '18px',
    },
  },
  cardCheckboxWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  cardOptionWrapper: {
    flex: 0,
    fontSize: '12px',
  },
  cardGhost: {
    opacity: 0.4,
    border: '2px dashed gold',
  },
});
